import React, { Component, useEffect, useState } from "react";
import { useParams } from "react-router";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  setCurrentLoad,
  setReqInfo_isLoading,
  setLoadBits,
} from "../../redux/load/load.actions";
import {
  selectReqInfoIsLoading,
  selectLoadBits,
} from "../../redux/load/load.selectors";
import WithSpinner from "../../HOC/WithSpinner.component";
import ReqInfo from "../../containers/ReqInfo/ReqInfo.component";

const SingleReq = ({ setCurrentLoad, setLoadBits, selectLoadBits }) => {
  const SERVER_API = "https://barnet.app/";
  const params = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [loadId, setLoadId] = useState();
  const WithSpinnerReqInfo = WithSpinner(ReqInfo);
  useEffect(() => {
    setLoadBits("");
    fetch(`${process.env.REACT_APP_API}get_load_single_request?id=${params.id}`)
      .then((res) => res.json())
      .then((res) => {
        setCurrentLoad(res[0]);
        setLoadId(res[0]._id);

        setIsLoading(false);
      })
      .catch((e) => console.log(e.message, e));
  }, []);

  useEffect(() => {
    if (loadId) {
      const data = { load_id: loadId };
      fetch(`${SERVER_API}get_load_bits_nologin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((res) => {
          console.log("res", res);
          setLoadBits(res);
        })
        .catch((err) => console.log(err.message));
    }
  }, [loadId]);
  console.log('bit',selectLoadBits)
  return (
    <div
      className="container my-lg-5 pt-5"
      style={{
        height: "100%",
      }}
    >
      <div>
        <WithSpinnerReqInfo isLoading={isLoading} />
      </div>
    </div>
  );
};
const mapDispatchToProps = (dispatch) => ({
  setCurrentLoad: (currenLoad) => dispatch(setCurrentLoad(currenLoad)),
  setReqInfo_isLoading: (loading) => dispatch(setReqInfo_isLoading(loading)),
  setLoadBits: (x) => dispatch(setLoadBits(x)),
});

const mapStateToProps = createStructuredSelector({
  reqInfoIsLoading: selectReqInfoIsLoading,
  selectLoadBits: selectLoadBits,
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleReq);
